import { DeleteOutlined } from '@ant-design/icons';
import { useTranslation } from '@framework/i18n';
import type { ModalProps } from 'antd';
import { Button, Modal } from 'antd';
import type { ButtonType } from 'antd/es/button';
import type { SizeType } from 'antd/es/config-provider/SizeContext';
import React from 'react';

export interface ModalConfirmProps extends ModalProps {
  loading?: boolean;
  size?: SizeType;
  iconOnlyButton?: boolean;
  buttonType?: ButtonType;
  buttonIcon?: React.ReactNode;
  buttonText?: string;
  buttonDanger?: boolean;
  onButtonClick: () => void;
  disabled?: boolean;
  children: React.ReactNode;
}

export function ModalConfirm(props: ModalConfirmProps) {
  const {
    loading,
    size,
    buttonType,
    buttonIcon,
    buttonText,
    iconOnlyButton,
    buttonDanger,
    onButtonClick,
    children,
    ...modalProps
  } = props;
  const { t } = useTranslation();

  return (
    <>
      <Button
        disabled={props.disabled}
        type={buttonType ?? 'primary'}
        icon={buttonIcon ?? <DeleteOutlined />}
        size={size ?? 'small'}
        loading={loading}
        danger={buttonDanger}
        onClick={onButtonClick}
      >
        {iconOnlyButton
          ? ''
          : buttonText ?? t('moddal.modal-confirm.delete', 'Elimina')}
      </Button>
      <Modal {...modalProps}>{children}</Modal>
    </>
  );
}
